<template>
    <div class="CardRenew">
        <navigation-bar Close/>
        <div class="container main pb-4">
            <h4 class="line mt-4">皆以TWD付款</h4>
            <div class="ml-4">
                共 1 項商品，總計 <span class="red">NT $300</span>
            </div>
            <div class="shadow-line"/>

            <h4 class="line mt-4">付款方式</h4>
            <el-radio-group v-model="radio">
                <el-radio label="1">
                    <h5>信用卡一次付清</h5>
                </el-radio>
                <el-radio label="2">
                    <h5>全家付款</h5>
                    <span>帳號將於訂單送出後提供</span>
                </el-radio>
                <el-radio label="3">
                    <h5>ATM付款</h5>
                    <span>帳號將於訂單送出後提供</span>
                </el-radio>
            </el-radio-group>
            <div class="shadow-line"/>

            <el-checkbox-group v-model="checkList">
                <el-checkbox label="1">
                    發票要打統編
                </el-checkbox>
                <el-checkbox label="2">
                    愛心捐贈發票
                </el-checkbox>
                <el-checkbox label="3">
                    願意收到活動與優惠相關內容
                </el-checkbox>
                <el-checkbox label="4">
                    <span class="small">我已經閱讀並同意會員權益暨隱私權條款</span>
                </el-checkbox>
            </el-checkbox-group>

            <div class="footer">
                <el-button type="info" round>取消</el-button>
                <el-button type="primary" round>結帳</el-button>
            </div>


        </div>

    </div>
</template>

<script>

    export default {
        name: "CardRenew",
        components: {

        },
        data() {
            return {
                radio:'',
                checkList:[],
            }
        },
        created() {

        },

        beforeUpdate() {

        },
        beforeDestroy() {

        },
        methods: {

        }
    }
</script>
<style lang="less" scoped src="../../less/gift.less"/>
